import { useMemo, useState } from 'react';
import { winnerCards } from '../data/winners';

const filterOptions = [
  'all',
  ...new Set([
    ...winnerCards.map((winner) => winner.year),
    ...winnerCards.flatMap((winner) =>
      winner.media.split('|').map((medium) => medium.trim())
    ),
  ]),
];

export default function Recipients() {
  const [activeFilter, setActiveFilter] = useState('all');

  const visibleRecipients = useMemo(() => {
    return [...winnerCards]
      .filter((winner) => {
        if (activeFilter === 'all') {
          return true;
        }

        if (winner.year === activeFilter) {
          return true;
        }

        return winner.media.split('|').map((medium) => medium.trim()).includes(activeFilter);
      })
      .sort((a, b) => Number(b.year) - Number(a.year));
  }, [activeFilter]);

  return (
    <section className="recipients-page">
      <div className="awards-band-wrap">
        <div className="awards-band" aria-label="Awards">
          <p className="general-header px-5 md:px-8" style={{ color: 'white', fontSize: '2.6rem', fontWeight: '400', textAlign: 'center'}}>
            Recipients
          </p>
          <p style={{ color: 'white', fontSize: '1.3rem', fontWeight: '400', textAlign: 'center' }}>
            1992-2024
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <div className="recipients-filter-panel">
          <div className="recipients-filter-group">
            <div className="recipients-filter-row">
              {filterOptions.map((filter) => (
                <button
                  key={filter}
                  type="button"
                  onClick={() => setActiveFilter(filter)}
                  className={`nav-link recipients-filter-chip ${activeFilter === filter ? 'nav-link-active' : ''}`}
                >
                  {filter === 'all' ? 'All' : filter}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="recipients-band-list">
        {visibleRecipients.map((winner) => (
          <a
            key={winner.id}
            href={winner.href}
            className="recipient-band"
            aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            style={{ '--recipient-image': `url(${winner.image})` }}
          >
            <span className="recipient-band-image" aria-hidden="true" />
            <div className="recipient-band-copy">
              <div className="recipient-band-portrait-wrap">
                <img className="recipient-band-portrait" src={winner.portrait} alt="" />
              </div>
              <div className="recipient-band-text">
                <span className="recipient-band-meta">{winner.year} | {winner.media}</span>
                <span className="recipient-band-name">{winner.name}</span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
